import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import haQrcode from '../images/haQrcode.png'

const HaAppQrcode = ({ qrcode, setQrcode }) => {
  return (
    <>
      <Modal
        show={qrcode}
        onHide={() => {
          setQrcode({ show: false, msg: '' })
        }}
        centered
      >
        <Modal.Body className="text-center">
          <h4 className="mb-2">{qrcode.msg}</h4>
          <h6>請協助個案安裝 APP，完成身份串接</h6>
          {/* TODO 換QRCODE */}
          <div className="qrcodeWrap my-3">
            <img className="w-100" src={haQrcode} alt="ha-logo" />
          </div>
          <h6>請以手機掃描 QRCode 下載 HA app</h6>
          <Button
            className="mt-3"
            onClick={() => {
              setQrcode({ show: false, msg: '' })
            }}
          >
            完成
          </Button>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default HaAppQrcode
